<template>
  <div>
    <v-row no-gutters align="center">
      <h2 class="headline font-weight-bold black--text mr-3">
        {{ $t(`operators.list-panel-title`) }}
      </h2>
      <v-btn
        v-if="hasWritePerm"
        color="primary"
        class="caption font-weight-bold"
        outlined
        small
        rounded
        @click="createNewUser"
      >
        {{ $t("operators.addNewUserBtn") }}
      </v-btn>
    </v-row>
    <!-- filters -->
    <slot name="filters"></slot>

    <v-row no-gutters>
      <div v-if="getGrouppedOperators.length == 0" align-center justify-center>
        <h5 class="title text-sm-center">
          {{ $t("operators.empty-content") }}
        </h5>
      </div>
      <v-row v-else no-gutters>
        <v-list class="operators-list mb-4" two-line subheader>
          <div
            v-for="(groupedOperatorsList, key) in getGrouppedOperators"
            :key="key"
          >
            <v-subheader :key="key" class="text-uppercase">
              <h2 class="font-weight-bold secondary--text">"{{ key }}"</h2>
            </v-subheader>
            <v-divider></v-divider>

            <!-- OPERATOR LIST ITEM -->
            <v-card
              elevation="0"
              class="user-general-info-container list-item mt-3"
              v-for="(operator, index) in groupedOperatorsList"
              :key="index"
            >
              <v-card-text>
                <v-row no-gutters align="center">
                  <v-col class="flex-grow-0 flex-shrink-1">
                    <v-icon class="mr-4" color="primary" x-large
                      >fas fa-user-circle</v-icon
                    >
                  </v-col>
                  <v-col class="flex-grow-1 flex-shrink-0">
                    <h3>
                      <div class="black--text">
                        <span class="text-capitalize">
                          <span class="secondary--text">{{
                            operator.surname
                          }}</span
                          >&nbsp;{{ operator.name }}</span
                        >
                      </div>
                    </h3>
                    <v-col class="pa-0">
                      <span class="font-weight-bold">{{
                        getTransalatedRoles(operator.roles)
                      }}</span>
                    </v-col>
                    <v-col class="pa-0">
                      <ul class="permissions-list ma-0 pa-0">
                        <li
                          v-for="(
                            permission, index
                          ) in getUserAllowedPortalAreas(operator.permission)"
                          :key="index"
                        >
                          <v-chip
                            small
                            color="primary"
                            @click.stop
                            class="font-weight-medium permissions-list__item-chip ma-1"
                            >{{ permission }}</v-chip
                          >
                        </li>
                      </ul>
                    </v-col>
                  </v-col>
                  <v-col class="flex-grow-0 flex-shrink-1">
                    <v-btn
                      rounded
                      outlined
                      small
                      color="primary"
                      class="caption font-weight-bold mb-1"
                      @click="editUser(operator.id)"
                      >{{ $t("operators.userProfileBtn") }}</v-btn
                    >
                    <v-btn
                      v-if="
                        !operator.username &&
                        operator.roles.length === 1 &&
                        operator.roles[0] === 'OPERATOR'
                      "
                      rounded
                      outlined
                      small
                      color="primary"
                      class="caption font-weight-bold mt-1"
                      @click="confirmResendUserToken(operator.id)"
                      >{{ $t("operators.resendUserTokenBtn") }}</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </v-list>
      </v-row>
    </v-row>
  </div>
</template>

<script>
import groupBy from "lodash/groupBy";

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      validForm: true,
      user: {
        id: "",
        name: "",
        surname: "",
        email: "",
        username: "",
        roles: ["OPERATOR"],
        permission: []
      },
      lastDividerTitle: "",
      page: 1,
      itemsPerPage: 6,
      paginationTotalVisible: 5
    };
  },
  created() {},
  computed: {
    hasWritePerm() {
      return this.$store.getters["auth/userHasRequiredAccess"](
        "GESTIONEPROFILI",
        "READWRITE"
      );
    },
    getGrouppedOperators() {
      return groupBy(this.items, operator =>
        operator.surname.charAt(0).toUpperCase()
      );
    }
  },
  methods: {
    resetForm() {
      this.user = {
        id: "",
        name: "",
        surname: "",
        email: "",
        username: "",
        roles: ["OPERATOR"],
        permission: []
      };
    },
    getTransalatedRoles(roles) {
      let ur = [...roles];
      let refIndex = ur.indexOf("REFERENT");
      if (refIndex > -1) {
        ur.splice(refIndex, 1);
      }
      let lrIndex = ur.indexOf("LEGALRAPRESENTATIVE");
      if (lrIndex > -1) {
        ur.splice(lrIndex, 1);
      }
      let userRoles = [];
      ur.forEach(r => {
        userRoles.push(this.$t(`userRoles.${r}`));
      });
      return userRoles.join(", ");
    },
    createNewUser() {
      this.openConfirmDialog("operators.newPage.instructionInfo");
    },
    openConfirmDialog(instructionKey) {
      let confirmConfig = {
        title: `${instructionKey}.title`,
        message: `${instructionKey}.text`,
        cancelBtnLabel: `${instructionKey}.cancelBtnLabel`,
        confirmBtnLabel: `${instructionKey}.proceedBtnLabel`,
        confirmBtnClb: this.proceedToCreateNewUser
      };
      this.$store.commit("confirm/openConfirmDialog", confirmConfig, {
        root: true
      });
    },
    proceedToCreateNewUser() {
      this.$router.push({ name: "operatorNew" });
    },
    closeDialog() {
      this.dialog = false;
      this.resetForm();
    },
    getUserAllowedPortalAreas(permList) {
      let userAvailablePortalAreas = [...permList].filter(
        p =>
          p.perm != "NOREAD" &&
          p.portalArea != "GESTIONENUOVERICHIESTE" &&
          p.portalArea != "PRESTAZIONIEFFETTUATE" &&
          p.portalArea != "NEWSTUTORIAL" &&
          p.portalArea != "FAQ"
      );
      let translatedItems = userAvailablePortalAreas.map(i =>
        this.getPermName(i.portalArea)
      );

      return translatedItems.sort((p1, p2) => p1.localeCompare(p2));
    },
    getPermName(perm) {
      return this.$t(`operators.permissionLabels.title.${perm}`);
    },
    editUser(id) {
      this.$router.push({ name: "operatorEdit", params: { id: id } }).catch(
        this.$store.commit("loading/CLOSE_LOADING_DIALOG", {
          root: true
        })
      );
    },
    confirmResendUserToken(id) {
      this.$store.commit("confirm/openConfirmDialog", {
        title: "operators.resendUserToken.confirm.title",
        message: "operators.resendUserToken.confirm.text",
        params: {},
        cancelBtnLabel: "cancelButton",
        cancelBtnClb: null,
        confirmBtnLabel: "confirmButton",
        confirmBtnClb: this.resendUserToken(id)
      });
    },
    resendUserToken(id) {
      return () => {
        this.$store
          .dispatch("operators/resendUserToken", id)
          .then(() => {})
          .catch(err => console.log(err));
      };
    }
  }
};
</script>

<style scoped>
.permissions-list {
  list-style-type: none;
}
.permissions-list li {
  display: inline;
}
.permissions-list__item-chip {
  color: white;
}
.has-colored-bg--card {
  background-color: var(card-bg);
}
.permissions-list__item {
  display: inline;
}
.permissions-list__item .v-chip {
  color: white !important;
}
.permissions-list__item:first-child .v-chip {
  padding-left: 0;
  margin-left: 0;
}
.has-bg-clr--card {
  background-color: var(--card-bg);
}
.operators-list {
  background-color: var(--card-bg);
  max-height: 1000px;
  overflow-y: auto;
  width: 100%;
}
.bg-color-white {
  background-color: white !important;
}
.v-subheader--inset {
  margin-left: 0px;
}
</style>
